import axios from 'axios';
import Constants from '../common/constants';

const queueTicketService = {
    generateTicket: ({ phoneNumber, serviceTypeId, fullName, program, captchaToken }) => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/generate`;
        return axios.post(url, { phoneNumber, serviceTypeId, fullName, program, captchaToken });
    },
    cancelTicket: (ticketNumber, trackingToken) => {
        const url = `${Constants.API_BASE_URL}/queue/ticket/cancel`;
        return axios.post(url, null, { params: { ticketNumber, trackingToken } });
    }
};

export default queueTicketService;
